import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/modules/shared.module";
import { ContractsComponent } from "./contract-list/contracts-list.component";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatTabsModule} from '@angular/material/tabs';
import { ContractsRoutingModule } from "./contracts.routing";
import { MatSortModule } from "@angular/material/sort";
import { ContractsViewModule } from "./contracts-view/contracts-view.module";
import { OverlayModule } from "@angular/cdk/overlay";
import { ContractAccessComponent } from "./contract-access/contract-access.component";
import { ContractsAccessListComponent } from "./contract-access/contract-access-list/contract-access-list.component";



@NgModule({
    declarations: [ ContractsComponent, ContractAccessComponent, ContractsAccessListComponent ],
    imports: [ ContractsViewModule, CommonModule, SharedModule, MatButtonModule, MatMenuModule, MatInputModule, MatFormFieldModule, MatSortModule, MatTableModule, MatPaginatorModule, MatCheckboxModule, MatTabsModule, OverlayModule ],
    exports: [ ContractsComponent, ContractsRoutingModule ],
    providers: [],
})
export class ContractsModule {}